export default class PasswordValidate {


    /**
     * 
     * @param {*} inputtxt 
     */  
    static CheckPassword(inputtxt) {
      var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
      if (inputtxt.match(passw)) {
        return true;
      } else {
        return false;
      }
    }
  
  
  }
  